import { message as antMessage } from 'antd'

export interface Message {
  error: (text: string) => void
  loading: (textOrOpts: string | object) => void
  success: (text: string) => void
  destroy: (key: string) => void
}
export const message: Message = antMessage as Message
